import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Box, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, TextField, FormControlLabel, Checkbox } from '@material-ui/core';
import { getDefaultSharedTextForClipboard } from '../helpers/misc';
import { Stack } from '@mui/material';

const ShareTextDialog = (props) => {
  const { open, setOpen, title, content, textYes, textNo, onClickYes, onClickNo, sharedText } = props
  const handleClose = () => {
    setOpen(false);
  };

  const [allCars, setAllCars] = useState(false)

  //////////////////////// app modal close feature //////////////////////////////////////////
  const appModalCloseTimestamp = useSelector((state) => state.layout.appModalCloseTimestamp);
  useEffect(() => {
    if (appModalCloseTimestamp) {
      setOpen(false)
    }
  }, [appModalCloseTimestamp]);
  ///////////////////////////////////////////////////////////////////////////////////////////

  const [value, setValue] = useState("")
  useEffect(() => {
    if (open) {
      setValue(sharedText)
    }
  }, [open, sharedText])

  const onClickReset = () => {
    const defaultValue = getDefaultSharedTextForClipboard()
    setValue(defaultValue)
    onClickYes(defaultValue, false, allCars)
  }

  const onChangeAllCars = (event) => {
    setAllCars(event.target.checked)
  }

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-shared-text"
    >
      {
        (title) && (
          <DialogTitle id="alert-dialog-title">
            {title}
          </DialogTitle>
        )
      }

      <DialogContent>
        <div style={{ width: '440px', maxWidth: '100%' }}>
          <TextField
            fullWidth
            label=""
            multiline={true}
            minRows={9}
            value={value}
            onChange={(e) => setValue(e.target.value)}
            variant="outlined" //standard, outlined
          />
        </div>
      </DialogContent>

      <DialogActions>
        <Stack direction={`row`} justifyContent={`space-between`} alignItems="center" spacing={3} style={{ width: '100%' }}>
          <Box>
            <Stack direction={`row`} justifyContent={`flex-start`} alignItems={`center`} spacing={1}>
              <FormControlLabel
                control={
                  <Checkbox checked={allCars}
                    onChange={(event) => onChangeAllCars(event)} />
                }
                label="All Cars"
              />
            </Stack>
          </Box>
          <Box>
            <>
              <Button onClick={() => onClickReset()}>{`Reset`}</Button>
            </>
            {
              (textYes) && (
                <>
                  <Button onClick={() => onClickYes(value, true, allCars)}>{textYes}</Button>
                </>
              )
            }
            {
              (textNo) && (
                <>
                  <Button onClick={onClickNo}>{textNo}</Button>
                </>
              )
            }
          </Box>
        </Stack>
      </DialogActions>
    </Dialog>
  );
};

export default ShareTextDialog;
